import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
// import stores
import { exitTheme } from '../../hookState/ThemeState';
// import utility and constants
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';

import AllEvents from './allEvents';
import { FULL_PERMISSION } from '../../constants/Constant';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));
const Events = (props) => {
    const classes = useStyles();
    const eventList = useState(null);
    const loading = useState(false);
    // const setAll = useState(false);
    const modPermission = FULL_PERMISSION;
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    useEffect(() => {
        getEventList();
        exitTheme();
    }, []);

    const getEventList = () => {
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_ALL_EVENTS)
            .then((res) => {
                let newData = res.data;
                Helper.setStorage('UserEvents', res.data);
                let eventData = [];
                // newData.map(item => item.selected = false);
                if (newData.length > 0) {
                    res.data.map((item) => {
                        eventData.push({
                            actualData: {
                                ...item,
                                statusName:
                                    item.status === 1
                                        ? 'Active'
                                        : item.status === 2
                                        ? 'Completed'
                                        : 'Cancelled',
                            },
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'eventID',
                                    eventUsersID: item.eventID,
                                    width: '0.05',
                                },
                                {
                                    label: 'Name',
                                    key: 'eventName',
                                    eventName: item.eventName,
                                    width: '0.25',
                                    showLabel: false,
                                    addLink: true,
                                    inColumn: true,
                                },
                                {
                                    label: 'Start On',
                                    key: 'startDate',
                                    startDate: Helper.FormatDate(
                                        item.startDate
                                    ),
                                    width: '0.2',
                                    inColumn: true,
                                },
                                {
                                    label: 'End On',
                                    key: 'endDate',
                                    endDate: Helper.FormatDate(item.endDate),
                                    width: '0.2',
                                    inColumn: true,
                                },
                                {
                                    label: 'Location',
                                    key: 'venue',
                                    venue: item.venue,
                                    width: '0.1',
                                    inColumn: true,
                                },
                                {
                                    label: 'Event Mode',
                                    key: 'readonlyOrHide',
                                    readonlyOrHide:
                                        item.readonlyOrHide === 0
                                            ? 'Publish'
                                            : item.readonlyOrHide === 1
                                            ? 'Read Only'
                                            : 'Hide',
                                    width: '0.1',
                                    inColumn: true,
                                },
                                {
                                    label: 'Status',
                                    key: 'status',
                                    status:
                                        item.status == 1
                                            ? 'Active'
                                            : item.status == 2
                                            ? 'Completed'
                                            : 'Cancelled',
                                    width: '0.1',
                                    inColumn: true,
                                },
                                {
                                    label: 'Action',
                                    key: 'edit',
                                    edit: 'Edit',
                                    width: '0.05',
                                },
                            ],
                            selected: false,
                        });
                    });
                }
                eventList.set(eventData);
                loading.set(false);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    console.log(error);
                }
                loading.set(false);
            });
    };

    // const selectAll = (event) => {
    //     setAll.set(event.target.checked);
    //     let newEventList = eventList.attach(Downgraded).get();
    //     newEventList.map((item) => (item['selected'] = event.target.checked));
    //     eventList.set(newEventList);
    // };

    // const onCheckSelect = (event, index) => {
    //     let newEventList = eventList.attach(Downgraded).get();
    //     newEventList[index]['selected'] = event.target.checked;
    //     const checkAll = newEventList.every((obj) => obj.selected === true);
    //     setAll.set(checkAll);
    //     eventList.set(newEventList);
    // };

    const deleteEvents = () => {
        const selected = eventList
            .get()
            .filter((event) => event.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select events first',
            });
        } else {
            let message =
                selected.length == eventList.get().length
                    ? 'Do you want to delete all events ?'
                    : 'Do you want to delete selected events ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleConfirmation = () => {
        let deleteEvents = [];
        eventList.get().map((event) => {
            if (event.selected === true) {
                deleteEvents.push(event.actualData.eventID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_EVENTS, {
            Ids: deleteEvents.join(','),
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Events deleted successfully',
                    });
                    getEventList();
                }
            })
            .catch((error) => {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting events';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    return (
        <Box className={loading.get() ? 'alignCenter' : 'otherContentBox'}>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : eventList.get() ? (
                <AllEvents
                    data={eventList.attach(Downgraded).get()}
                    // setAll={setAll.attach(Downgraded).get()}
                    // selectAll={selectAll}
                    // onCheckSelect={onCheckSelect}
                    deleteEvents={deleteEvents}
                    modPermission={modPermission}
                    {...props}
                />
            ) : null}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENTS,
        component: Events,
    },
    name: 'Events',
};
